import { render, staticRenderFns } from "./GoToEntityForm.vue?vue&type=template&id=cd4f5ac6"
import script from "./GoToEntityForm.vue?vue&type=script&lang=js"
export * from "./GoToEntityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports